import { GameVars } from "../../../GameVars";

export class LocksCounter extends Phaser.GameObjects.Container {

    private background: Phaser.GameObjects.Image;   
    private icons: Phaser.GameObjects.Image[] = [];
    private lastCount: number;
    private transitioning: boolean;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.y = 120;
        this.setScale(1.8);

        this.transitioning = false;
        this.lastCount = 4;

        this.background = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "slot_3_locks");
        this.add(this.background);

        this.icons = [];

        for (let i = 0; i < 3; i++) {
            const icon = new Phaser.GameObjects.Image(this.scene, -29 + i * 29, 0, "texture_atlas_1", "icon_lock");
            this.add(icon);
            this.icons.push(icon);
        }
    }

    public update(): void {

        if (GameVars.gameOver ) {
            return;
        }

        const state = GameVars.cardCrawlEngine.getState();
        const count = state.upperTableau.filter(element => element != null).length;

        if (this.lastCount !== count && !this.transitioning) {

            if (this.lastCount === 2 && count === 4) {
                this.updateIcons(1);
            } else {
                this.updateIcons(count);
                this.lastCount = count;
            }
        }
    }

    private updateIcons(count: number): void {

        if (!this.scene) {
            return;
        }

        this.transitioning = true;

        this.scene.time.delayedCall(350, function() {

            this.transitioning = false;

            const n = 4 - count;

            for (let i = 0; i < 3; i++) {
                if (i < n) {
                    this.icons[i].setFrame("icon_check");
                } else {
                    this.icons[i].setFrame("icon_lock");
                }
            }

            if (count === 1) {
                this.scene.time.delayedCall(1250, function() {
                    this.lastCount = -1;
                    this.updateIcons(4);
                }, [], this);
            }
        }
        , [], this);
    }
}